export const EVENT_LIST = {
  Register: "Register",
  Login: "Login",
  OTP_Enter: "OTP_Enter",
  Click_direct_link_app: "Click_direct_link_app",
  eCRM: {
    phone_number_enter: "phone_number_enter",
    otp_accepted: "otp_accepted",
    user_enter_social: "user_enter_social",
    click_capsule_button: "click_capsule_button",
    click_stores_button: "click_stores_button",
    capsule_guide_view: "capsule_guide_view",
    click_capsule_activation_button: "click_capsule_activation_button",
    capsule_activation: "capsule_activation",
    click_add_post_button: "click_add_post_button",
    successful_post_publish: "successful_post_publish",
    click_save_promotion: "click_save_promotion",
    complete_save_promotion: "complete_save_promotion",
    stores_page_view: "stores_page_view",
    click_store: "click_store",
    click_purchase_from_stores: "click_purchase_from_stores",
    search: "search",
    click_add_cart: "click_add_cart",
    complete_add_cart: "complete_add_cart",
    click_cash_in: "click_cash_in",
    complete_cash_in: "complete_cash_in",
  },
};
export const EVENT_TOKEN = {
  Register: "07lgz0",
  Login: "fp100s",
  OTP_Enter: "ne5t61",
  Click_direct_link_app: "vsax8l",
};

export const EVENT_LIST_KEYS = {
  phone_number: "phone_number",
  phone: "phone",
  has_registered: "has_registered",
  userId: "userId",
  apk_version: "apk_version",
  referralCode: "referralCode",
  ecrmPhoneNumber: "phoneNumber",
  clickPosition: "clickPosition",
};

export const ECRM_EVENT_LIST = {
  login: "identify",
  logout: "reset",
  updateProfile: "updateProfile",
  injectDevice: "injectDevice",
  trackFireBaseToken: "trackFireBaseToken",
};
